function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1037.3,5011.7C628.6,4956,269.8,4649,143.1,4244.1c-51.8-165-55.6-443.3-9.6-602.5c86.4-289.8,25-222.6,1734.7-1934.3l1587-1588.9l-1587-1587C158.5-3182.3,219.9-3115.1,133.5-3404.9c-48-159.3-44.1-439.4,9.6-602.6c109.4-347.3,385.7-621.7,731.1-731.1c163.1-53.7,443.3-57.6,602.6-9.6c289.8,86.3,222.6,24.9,1936.2,1734.7l1587,1587l1588.9-1587c1711.7-1709.8,1644.5-1648.4,1934.3-1734.7c159.3-48,439.5-44.2,602.6,9.6c347.3,109.4,621.8,385.7,731.1,731.1c53.7,163.1,57.6,443.3,9.6,602.6c-86.3,289.8-24.9,222.6-1734.7,1936.2l-1587,1587l1587,1588.9c1709.8,1711.7,1648.4,1644.6,1734.7,1934.3c48,159.3,44.2,439.4-9.6,602.5c-109.4,345.4-383.8,621.7-731.1,731.1c-163.1,53.7-443.3,57.6-602.6,9.6c-289.8-86.3-222.6-25-1934.3-1734.7L5000,1663.1l-1587,1587c-1381.7,1379.7-1604.2,1592.7-1706,1642.6C1490.2,5002.1,1259.9,5042.4,1037.3,5011.7z"
})));

var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exit.5797fd22.svg";
export { ForwardRef as ReactComponent };